
      export default {
  "__schema": {
    "types": [
      {
        "kind": "INTERFACE",
        "name": "AdsAdvertisementEntity",
        "possibleTypes": [
          {
            "name": "AdsAdvertisementHtmlEmbed"
          },
          {
            "name": "AdsAdvertisementImage"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "BrochureLogEntity",
        "possibleTypes": [
          {
            "name": "AssigneeBrochureLog"
          },
          {
            "name": "CreateBrochureLog"
          },
          {
            "name": "PositionBrochureLog"
          },
          {
            "name": "StateBrochureLog"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "GenericTreeItem",
        "possibleTypes": [
          {
            "name": "GenericProductCategoryEntity"
          },
          {
            "name": "GenericProductEntity"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "HotspotEntity",
        "possibleTypes": [
          {
            "name": "HotspotImageEntity"
          },
          {
            "name": "HotspotLinkEntity"
          },
          {
            "name": "HotspotProductEntity"
          }
        ]
      },
      {
        "kind": "UNION",
        "name": "NewsletterSubscriberStatus",
        "possibleTypes": [
          {
            "name": "NewsletterSubscriberActive"
          },
          {
            "name": "NewsletterSubscriberDeleted"
          }
        ]
      },
      {
        "kind": "INTERFACE",
        "name": "WebsitePageEntity",
        "possibleTypes": [
          {
            "name": "WebsitePagePage"
          },
          {
            "name": "WebsitePagePost"
          }
        ]
      }
    ]
  }
}
    